// extracted by mini-css-extract-plugin
module.exports = {"Loader-wrapper":"loader_Loader-wrapper__2SjX8","loader":"loader_loader__3YnrM","Table":"loader_Table__33vGj"};